define( function() {
	return ( /^margin/ );
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/css/var/rmargin.js
 ** module id = 828
 ** module chunks = 2
 **/